angular.module('gym.components').directive('kioskLinks', function() {
  return {
    restrict: 'E',
    template: require('templates/components/calendar/kiosk_links.html.slim'),
    scope: {
      dashboard: '='
    },
    controller: ["$scope", "$stateParams", "flash", "EmploymentService", "KioskService", function($scope, $stateParams, flash, EmploymentService, KioskService) {
      var showError;
      $scope.permissions = EmploymentService.get().permissions;
      $scope.selectedOption = 'general_attendance';
      $scope.setOption = function(option) {
        $scope.selectedOption = option;
        return $scope.enter();
      };
      $scope.enter = function() {
        switch ($scope.selectedOption) {
          case 'general_attendance':
            return $scope.onKioskModeClick();
          case 'class':
            return $scope.onClassKioskModeClick();
          case 'roll_call':
            return $scope.onRollCallClick();
        }
      };
      showError = function() {
        return flash.error = 'Sorry, you do not have permission to view this page.';
      };
      $scope.onKioskModeClick = function() {
        if ($scope.permissions.general_kiosk_mode) {
          return KioskService.enterKioskMode();
        } else {
          return showError();
        }
      };
      $scope.onClassKioskModeClick = function() {
        var params;
        if ($scope.permissions.class_kiosk_mode) {
          params = {
            location_id: $stateParams.location_id
          };
          return KioskService.enterClassKioskMode(params);
        } else {
          return showError();
        }
      };
      return $scope.onRollCallClick = function() {
        if ($scope.permissions.roll_call) {
          return KioskService.enterRollCall();
        } else {
          return showError();
        }
      };
    }]
  };
});
